<template>
    <span>
        <b-button
            class="align-baseline"
            title="Delete Tooltip"
            v-b-modal="deleteModalId"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalId"
            title="Delete tooltip"
            @shown="onModalShown"
            @ok="deleteTooltip"
        >Permanently delete tooltip #{{tooltipId}}?</modal>
    </span>
</template>

<script>
    import API from '../../../.././api';
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                tooltipId: 0,
                deleteModalId: '',
            };
        },
        created() {
            this.tooltipId = this.params.data.id;
            this.deleteModalId = `modal-delete-tooltip-${this.tooltipId}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            async deleteTooltip() {
                try {
                    await API.delete(`/app/partner-cards/tooltip/${this.tooltipId}/`);
                } catch (error) {
                    const response = error.response;
                    const detail =
                        response && response.data && response.data.detail
                            ? ' ' + response.data.detail
                            : '';
                    this.errorToast({ text: `Could not delete tooltip.${detail}`})
                    return;
                }
                this.params.api.applyTransaction({
                    remove: [this.params.node],
                });
            },
        },
    };
</script>
